
import { Options, Vue } from "vue-class-component";
import ComponentLibrary from "./ComponentLibrary.vue";
import * as data from "./data/data.json";
import Main from "./Main.vue";
import Guest from "./Guest.vue";
import Event from "./Event.vue";
import EventNoMedia from "./EventNoMedia.vue";
import GuestNoMedia from "./GuestNoMedia.vue";
// @ts-ignore
import PreLoader from "./components/PreLoader.vue";
import Schedule from "./Schedule.vue";

@Options({
  components: {
    ComponentLibrary,
    Main,
    Guest,
    GuestNoMedia,
    Event,
    EventNoMedia,
    Schedule,
    PreLoader,
  },
  data() {
    return {
      preloader: true,
    };
  },
  created() {
    setTimeout(() => (this.preloader = false), 2500);
  },
  methods: {
    removeTransparency(color: string) {
      const value = color.slice(3);
      return color.length > 7 ? `#${value}` : color;
    },
    hexToRgb(hex: any) {
      const result = hex
        .replace(
          /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
          (m: any, r: any, g: any, b: any) => "#" + r + r + g + g + b + b
        )
        .substring(1)
        .match(/.{2}/g)
        .map((x: any) => parseInt(x, 16));
      return `rgba(${result.toString()},0.3)`;
    },
  },
  computed: {
    cssVars() {
      return {
        "--colorPrimary": this.removeTransparency(this.path.colorPrimary),
        "--colorPrimaryDark": this.removeTransparency(
          this.path.colorPrimaryDark
        ),
        "--colorPrimaryLight": this.removeTransparency(
          this.path.colorPrimaryLight
        ),
        "--colorAccent": this.removeTransparency(this.path.colorAccent),
        "--colorControlActivated": this.removeTransparency(
          this.path.colorControlActivated
        ),
        "--colorControlHighlight": this.removeTransparency(
          this.path.colorControlHighlight
        ),
        "--colorMenuBackground": this.removeTransparency(
          this.path.colorMenuBackground
        ),
        "--colorMenuForeground": this.removeTransparency(
          this.path.colorMenuForeground
        ),
        "--colorPrimaryLightest": this.hexToRgb(
          this.removeTransparency(this.path.colorPrimaryLight)
        ),
      };
    },
  },
})
export default class App extends Vue {
  path = data.data.applicationConfig;
}
